import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { IUserProfileClaim } from '@gik/calendar/models/Claim';
import ClaimsListSkeleton from './ClaimsListSkeleton';
import ClaimedItemsList from './ClaimedItemsList';

export interface IClaimsListProps {
  items?: IUserProfileClaim[];
  loading?: boolean;
  emptyText: string;
  className?: string;
}

const blockName = 'claims-list';

function ClaimsList({ items, loading, emptyText, className }: IClaimsListProps) {
  const bem = bemBlock(blockName);

  if (loading) return <ClaimsListSkeleton />;

  if (items?.length === 0) {
    return (
      <div className={bem(null, 'empty')}>
        <div />
        <div>
          <span className={bem('empty-text')}>{emptyText}</span>
        </div>
        <div />
      </div>
    );
  }

  return <ClaimedItemsList className={className} items={items} />;
}

export default ClaimsList;
